<template>
    <swatch-button-group
        :item-data="itemData"
        :option-name="placement.code"
        :options="placement.components"
        :group-by="placement.custom['v-placement-group-by']"
        :group-by-label="placement.custom['v-placement-group-by-label']"
        :group-by-default="placement.custom['v-placement-group-by-default']"
        :selected-value="placement.selectedValue"
        :variant="getPlacementVariant(placement)"
        @selection-changed="selectValue(placement, $event)"
    />
</template>

<script>
    import SwatchButtonGroup from './SwatchButtonGroup.vue';

    import allStores from '../../stores/all';

    export default {
        mixins: [allStores],

        components: {
            SwatchButtonGroup,
        },

        props: {
            itemData: Object,
            placement: {
                type: Object,
                required: true,
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },
        },

        methods: {
            getPlacementVariant(placement) {
                return placement?.custom?.['v-placement-variant'];
            },

            selectValue(placement, option) {
                this.customizerStore.setSelection(placement.code, option.value, false);
            },
        },
    };
</script>
